export default __webpack_public_path__ + "static/media/fileupload.5d070e82.svg";